<template>
  <div class="tooltip-wrapper">{{ showTooltip.tooltipSelector }}</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Tooltip",
  computed: {
    ...mapGetters("main", ["showTooltip"])
  },
  props: {
    direction: {
      type: String
    },
    group: {
      type: String
    },
    tooltipSelector: {
      type: String
    }
  },
  methods: {
    setTooltipObjectVuex() {
      // Function sets tooltip object in vuex
      this.$store.commit("main/setTooltipObj", {
        group: this.group,
        coordinates: this.getTooltipCoordinates(event),
        tooltipSelector: this.tooltipSelector
      });
    },
    getTooltipCoordinates(event) {
      // clientX/Y gives the coordinates relative to the viewport in CSS pixels.
      // return {x: event.clientX, y: event.clientY}
      // console.log(event.clientX);
      // console.log(event.clientY);

      // pageX/Y gives the coordinates relative to the <html> element in CSS pixels.
      return { x: event.pageX, y: event.pageY };
      // console.log(event.pageX);
      // console.log(event.pageY);

      // screenX/Y gives the coordinates relative to the screen in device pixels.
      // return {x: event.screenX, y: event.screenY}
      // console.log(event.screenX);
      // console.log(event.screenY);
    }
  },
  mounted() {
    this.setTooltipObjectVuex();
    // console.log(this.showTooltip)
  }
};
</script>

<style scoped lang="scss">
.tooltip-wrapper {
  position: absolute;
  background-color: black;
  color: white;
  z-index: 10;
  padding: 3px 5px;
  border-radius: 15px;
  /*left: 29%;*/
  top: -72%;
  width: fit-content;
  white-space: nowrap;
}
</style>
